import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { useContext } from "react";
import { DealerUserRole } from "@/gql/graphql";
import AccessDenied from "@/pages/AccessDenied";
import { pageLayout } from "@/theme/pageLayout";
import { MeContext } from "@/context/me/MeContext";

type DealerOwnerRoleGateProps = {
  children: ReactNode;
};

const accessDenied = (variant: "meForbidden" | "default" = "default") => (
  <Box sx={pageLayout}>
    <AccessDenied variant={variant} />
  </Box>
);

export function DealerOwnerRoleGate(props: DealerOwnerRoleGateProps) {
  const { children } = props;

  const meContext = useContext(MeContext);
  const me = meContext?.me;

  if (!me) {
    return accessDenied("meForbidden");
  }

  const isDealerOwner =
    me.role === DealerUserRole.DealerOwner ||
    me.role === DealerUserRole.DealerSecondaryOwner;

  if (!isDealerOwner) {
    return accessDenied();
  }

  return children;
}
